module.exports = __webpack_public_path__ + "img/ProfilePic3.76432071.png";